import { LazyImage } from "src/components/common/lazy-image/LazyImage";
import styles from "./styles.module.css";

const id = "6300421054042735";

const EtbisMedia = () => {
  return (
    <div className={styles.wrapper}>
      <div id="ETBIS">
        <div id={id}>
          <a href={`https://etbis.eticaret.gov.tr/sitedogrulama/${id}`} target="_blank" rel="noreferrer">
            <LazyImage style={{ width: "100px", height: "120px" }} src="/assets/images/etbis_logo.jpeg" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default EtbisMedia;
